webpackJsonp([238950454183692],{

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;& ul{list-style-type:none;color:', _colors2.default.primary, ';}h1,h2{padding-bottom:0.5em;}h2{padding-top:1em;}}'); /* eslint-disable no-undef, react/prop-types */
	
	
	var linkStyle = /*#__PURE__*/(0, _reactEmotion.css)('color:', _colors2.default.primary, ';text-decoration:underline;&:hover{text-decoration:none;}');
	
	var English = function English() {
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        className: style,
	        width: [1, 1, 1 / 2],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.secondary
	      },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Owla and the Hidden Hearth'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Owla and the Hidden Hearth is a thrilling adventure that combines the magic of fairy tales with elements from Finnish folklore and the local history of Oulu. More than 90 performers \u2013 professional dancers, amateur folk dancers, and musicians \u2013 lead you from the alleys and parks of Owla to the far corners of this mystical world. In the city of Owla you will meet charming characters, see skillful dancing, and hear beautiful music.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Performances'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Wednesday 6th of June, 7:00 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Thursday 7th of June, 6:00 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Friday 8th of June, 6:00 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Saturday 9th of June, 2:00 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Saturday 9th of June, 6:00 pm'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Sunday 10th of June, 1:00 pm'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Location'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Valvesali',
	        _react2.default.createElement('br', null),
	        'Kulttuuritalo Valve',
	        _react2.default.createElement('br', null),
	        'Hallituskatu 7, 90100 Oulu',
	        _react2.default.createElement('br', null),
	        'Running time: 1 hour 50 minutes inc. interval'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Tickets'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '15\u20AC / 10\u20AC for children under 10'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Kulttuuritalo Valve Ticket Shop',
	        _react2.default.createElement('br', null),
	        'Hallituskatu 7, Oulu',
	        _react2.default.createElement('br', null),
	        'Open Wed\u2013Sun 12\u201319,',
	        _react2.default.createElement('br', null),
	        'tel. (08) 5584 7575',
	        _react2.default.createElement('br', null),
	        '(No service fee)'
	      ),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        {
	          className: linkStyle,
	          href: 'https://www.ticketmaster.fi/search/?keyword=owla+ja+kadonnut+walkia',
	          target: '_blank',
	          rel: 'noopener'
	        },
	        'Ticketmaster.fi'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '(Ticketmaster outlets in Finland collect their own service fees)'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Inquiries'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Hanna Poikela,',
	        ' ',
	        _react2.default.createElement(
	          'a',
	          { href: 'mailto:hanna.poikela@gmail.com' },
	          'hanna.poikela@gmail.com'
	        )
	      )
	    )
	  );
	};
	
	exports.default = English;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-english-js-da40c30a7a763a38e54e.js